import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EntradaInserirComponent } from './entrada-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: EntradaInserirComponent }
    ])],
    exports: [RouterModule]
})
export class EntradaInserirRoutingModule { }
